package com.example.mystybag.sharedmodels.project.requestModels.nomenclatures

import com.example.mystybag.sharedmodels.AllCommands.GET_ALLERGENS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class GetAllergensRequestModel(
    val businessCategoryId: Long? = null
) : BaseRequestModel(api = GET_ALLERGENS)

